/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export const SchoolTableActions = ({
  row,
  openEditSchoolPage,
  openActivateSchoolDialog,
}) => {
  return (
    <>
      <OverlayTrigger
        overlay={<Tooltip id="school-edit-tooltip">Edit School</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mr-1 py-2 px-3 px-xxl-5 my-1"
          onClick={() => {
            openEditSchoolPage(row.school_information_id);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>

      {row.active_id === 1 ? (
        <OverlayTrigger
          overlay={
            <Tooltip id="school-deactivate-tooltip">Deactivate School</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-1 py-2 px-3 px-xxl-5 my-1"
            onClick={() => {
              openActivateSchoolDialog(row.school_information_id, false);
            }}
          >
            <i className="fa fa-power-off text-success"></i>
          </a>
        </OverlayTrigger>
      ) : (
        <OverlayTrigger
          overlay={
            <Tooltip id="school-activate-tooltip">Activate School</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-1 py-2 px-3 px-xxl-5 my-1"
            onClick={() => {
              openActivateSchoolDialog(row.school_information_id, true);
            }}
          >
            <i className="fa fa-power-off"></i>
          </a>
        </OverlayTrigger>
      )}
    </>
  );
};
